export default "__VITE_ASSET__e33f4bf3__"